import { categories } from '@/mocks/categories';
import { categoryImages } from '@/mocks/images';

export default function CategoryGrid() {
  return (
    <section className="py-12 md:py-16" style={{ backgroundColor: 'oklch(var(--background-50))' }}>
      <div className="section-container">
        <h2 className="font-heading font-semibold text-xl md:text-2xl text-center mb-2 text-foreground-950">
          Shop by Category
        </h2>
        <p className="text-sm text-center mb-8 text-foreground-600">
          Discover our complete range of products available on VigorBuy Spreadsheet
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-lg overflow-hidden transition-all duration-300 cursor-pointer"
              style={{ backgroundColor: 'oklch(var(--background-100))' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div className="w-full aspect-square overflow-hidden">
                <img
                  src={categoryImages[cat.name] || ''}
                  alt={`${cat.name} - VigorBuy Spreadsheet Collection`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 text-center">
                <span className="text-xs md:text-sm font-medium whitespace-nowrap text-foreground-800 group-hover:text-primary-600 transition-colors duration-300">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="btn-primary text-sm px-8 py-3 rounded-lg"
          >
            <i className="ri-shopping-bag-line mr-2"></i>
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}